import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const PenInSquareIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.761 10.0827C12.5732 10.2704 12.3188 10.3763 12.0532 10.377L10.6279 10.3811C10.3603 10.3819 10.1035 10.2759 9.91435 10.0867C9.72518 9.89756 9.61924 9.64077 9.62 9.37323L9.62406 7.94789C9.62482 7.68234 9.73064 7.42788 9.91841 7.2401L15.8642 1.29436C16.2566 0.901879 16.893 0.901882 17.2854 1.29436L18.7067 2.71565C18.8952 2.90412 19.0008 3.16006 19.0008 3.4266C19.0008 3.69315 18.8952 3.94846 18.7067 4.13693L12.761 10.0827ZM10.6291 7.95075L14.4429 4.13693L15.8642 5.55822L12.0503 9.37204L10.625 9.3761L10.6291 7.95075ZM16.5748 2.005L17.9961 3.42629L16.5748 4.84757L15.1535 3.42629L16.5748 2.005Z"
          fill={color}
        />
        <path
          d="M5.25 3H12.0372L10.5372 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V14.75C4.5 15.1642 4.83579 15.5 5.25 15.5H14.75C15.1642 15.5 15.5 15.1642 15.5 14.75V9.46498L17 7.96498V14.75C17 15.9926 15.9926 17 14.75 17H5.25C4.00736 17 3 15.9926 3 14.75V5.25C3 4.00736 4.00736 3 5.25 3Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
